/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateDocumentsubtypeDto } from '../models/work-create-documentsubtype-dto';
import { WorkDocumentsubtype } from '../models/work-documentsubtype';
import { WorkDocumentsubtypeAmountForProjectDto } from '../models/work-documentsubtype-amount-for-project-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateDocumentsubtypeDto } from '../models/work-update-documentsubtype-dto';

@Injectable({ providedIn: 'root' })
export class WorkDocumentsubtypesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentsubtypesV2ControllerGetAllDropdownOptions()` */
  static readonly DocumentsubtypesV2ControllerGetAllDropdownOptionsPath = '/v2/documentsubtypes/dropdown-options';

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsubtypesV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsubtypesV2ControllerGetAllDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsubtypesV2Service.DocumentsubtypesV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsubtypesV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsubtypesV2ControllerGetAllDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.documentsubtypesV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `documentsubtypesV2ControllerFindAll()` */
  static readonly DocumentsubtypesV2ControllerFindAllPath = '/v2/documentsubtypes';

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsubtypesV2ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsubtypesV2ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocumentsubtype>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsubtypesV2Service.DocumentsubtypesV2ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocumentsubtype>>;
      })
    );
  }

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsubtypesV2ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsubtypesV2ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDocumentsubtype>> {
    return this.documentsubtypesV2ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocumentsubtype>>): Array<WorkDocumentsubtype> => r.body)
    );
  }

  /** Path part for operation `documentsubtypesV2ControllerCreate()` */
  static readonly DocumentsubtypesV2ControllerCreatePath = '/v2/documentsubtypes';

  /**
   * Required permissions: documenttypes:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsubtypesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsubtypesV2ControllerCreate$Response(
    params: {
      body: WorkCreateDocumentsubtypeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDocumentsubtype>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsubtypesV2Service.DocumentsubtypesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDocumentsubtype>;
      })
    );
  }

  /**
   * Required permissions: documenttypes:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsubtypesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsubtypesV2ControllerCreate(
    params: {
      body: WorkCreateDocumentsubtypeDto
    },
    context?: HttpContext
  ): Observable<WorkDocumentsubtype> {
    return this.documentsubtypesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDocumentsubtype>): WorkDocumentsubtype => r.body)
    );
  }

  /** Path part for operation `documentsubtypesV2ControllerFindAllPaginated()` */
  static readonly DocumentsubtypesV2ControllerFindAllPaginatedPath = '/v2/documentsubtypes/paginated';

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsubtypesV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsubtypesV2ControllerFindAllPaginated$Response(
    params?: {
      withDocumenttype?: boolean;
      withDocumenttypeContainerTyp?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by documenttypeId query param.
     *           <p>
     *              <b>Format: </b> filter.documenttypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.documenttypeId=$not:$like:John Doe&filter.documenttypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.documenttypeId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>active</li>
     * <li>documenttypeId</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'active:ASC' | 'active:DESC' | 'documenttypeId:ASC' | 'documenttypeId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkDocumentsubtype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'documenttypeId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsubtypesV2Service.DocumentsubtypesV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('withDocumenttype', params.withDocumenttype, {});
      rb.query('withDocumenttypeContainerTyp', params.withDocumenttypeContainerTyp, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('filter.documenttypeId', params['filter.documenttypeId'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkDocumentsubtype>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'active'?: (string | Array<string>);
        'documenttypeId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsubtypesV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsubtypesV2ControllerFindAllPaginated(
    params?: {
      withDocumenttype?: boolean;
      withDocumenttypeContainerTyp?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by documenttypeId query param.
     *           <p>
     *              <b>Format: </b> filter.documenttypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.documenttypeId=$not:$like:John Doe&filter.documenttypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.documenttypeId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>active</li>
     * <li>documenttypeId</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'active:ASC' | 'active:DESC' | 'documenttypeId:ASC' | 'documenttypeId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkDocumentsubtype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'documenttypeId'?: (string | Array<string>);
};
};
}> {
    return this.documentsubtypesV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkDocumentsubtype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'documenttypeId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkDocumentsubtype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'documenttypeId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `documentsubtypesV2ControllerFindAllByDocumenttypeId()` */
  static readonly DocumentsubtypesV2ControllerFindAllByDocumenttypeIdPath = '/v2/documentsubtypes/{documenttypeId}';

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsubtypesV2ControllerFindAllByDocumenttypeId()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsubtypesV2ControllerFindAllByDocumenttypeId$Response(
    params: {
      documenttypeId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocumentsubtype>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsubtypesV2Service.DocumentsubtypesV2ControllerFindAllByDocumenttypeIdPath, 'get');
    if (params) {
      rb.path('documenttypeId', params.documenttypeId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocumentsubtype>>;
      })
    );
  }

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsubtypesV2ControllerFindAllByDocumenttypeId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsubtypesV2ControllerFindAllByDocumenttypeId(
    params: {
      documenttypeId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocumentsubtype>> {
    return this.documentsubtypesV2ControllerFindAllByDocumenttypeId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocumentsubtype>>): Array<WorkDocumentsubtype> => r.body)
    );
  }

  /** Path part for operation `documentsubtypesV2ControllerFindById()` */
  static readonly DocumentsubtypesV2ControllerFindByIdPath = '/v2/documentsubtypes/{id}';

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsubtypesV2ControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsubtypesV2ControllerFindById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDocumentsubtype>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsubtypesV2Service.DocumentsubtypesV2ControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDocumentsubtype>;
      })
    );
  }

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsubtypesV2ControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsubtypesV2ControllerFindById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkDocumentsubtype> {
    return this.documentsubtypesV2ControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDocumentsubtype>): WorkDocumentsubtype => r.body)
    );
  }

  /** Path part for operation `documentsubtypesV2ControllerDelete()` */
  static readonly DocumentsubtypesV2ControllerDeletePath = '/v2/documentsubtypes/{id}';

  /**
   * Required permissions: documenttypes:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsubtypesV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsubtypesV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsubtypesV2Service.DocumentsubtypesV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: documenttypes:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsubtypesV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsubtypesV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.documentsubtypesV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `documentsubtypesV2ControllerUpdate()` */
  static readonly DocumentsubtypesV2ControllerUpdatePath = '/v2/documentsubtypes/{id}';

  /**
   * Required permissions: documenttypes:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsubtypesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsubtypesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateDocumentsubtypeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsubtypesV2Service.DocumentsubtypesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: documenttypes:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsubtypesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsubtypesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateDocumentsubtypeDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.documentsubtypesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `documentsubtypesV2ControllerFindByDocumenttypeIdentifier()` */
  static readonly DocumentsubtypesV2ControllerFindByDocumenttypeIdentifierPath = '/v2/documentsubtypes/bydoctypeidentifier/{documenttypeIdentifier}';

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsubtypesV2ControllerFindByDocumenttypeIdentifier()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsubtypesV2ControllerFindByDocumenttypeIdentifier$Response(
    params: {
      documenttypeIdentifier: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocumentsubtype>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsubtypesV2Service.DocumentsubtypesV2ControllerFindByDocumenttypeIdentifierPath, 'get');
    if (params) {
      rb.path('documenttypeIdentifier', params.documenttypeIdentifier, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocumentsubtype>>;
      })
    );
  }

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsubtypesV2ControllerFindByDocumenttypeIdentifier$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsubtypesV2ControllerFindByDocumenttypeIdentifier(
    params: {
      documenttypeIdentifier: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocumentsubtype>> {
    return this.documentsubtypesV2ControllerFindByDocumenttypeIdentifier$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocumentsubtype>>): Array<WorkDocumentsubtype> => r.body)
    );
  }

  /** Path part for operation `documentsubtypesV2ControllerGetDocumentsubtypesByDocumenttypeIdWithAmountForProjects()` */
  static readonly DocumentsubtypesV2ControllerGetDocumentsubtypesByDocumenttypeIdWithAmountForProjectsPath = '/v2/documentsubtypes/getDocumentsubtypesByDocumenttypeIdWithAmountForProjects/{documenttypeId}';

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsubtypesV2ControllerGetDocumentsubtypesByDocumenttypeIdWithAmountForProjects()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsubtypesV2ControllerGetDocumentsubtypesByDocumenttypeIdWithAmountForProjects$Response(
    params: {
      documenttypeId: number;
      projectIds?: Array<number>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocumentsubtypeAmountForProjectDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsubtypesV2Service.DocumentsubtypesV2ControllerGetDocumentsubtypesByDocumenttypeIdWithAmountForProjectsPath, 'get');
    if (params) {
      rb.path('documenttypeId', params.documenttypeId, {});
      rb.query('projectIds', params.projectIds, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocumentsubtypeAmountForProjectDto>>;
      })
    );
  }

  /**
   * Required permissions: documenttypes:read, documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsubtypesV2ControllerGetDocumentsubtypesByDocumenttypeIdWithAmountForProjects$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsubtypesV2ControllerGetDocumentsubtypesByDocumenttypeIdWithAmountForProjects(
    params: {
      documenttypeId: number;
      projectIds?: Array<number>;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocumentsubtypeAmountForProjectDto>> {
    return this.documentsubtypesV2ControllerGetDocumentsubtypesByDocumenttypeIdWithAmountForProjects$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocumentsubtypeAmountForProjectDto>>): Array<WorkDocumentsubtypeAmountForProjectDto> => r.body)
    );
  }

}
